import * as React from 'react';
import { toast } from 'react-toastify';
import { DmvVehicleData } from './DriversLicenseLookupOptions';

import * as urls from '../../../shared/urls';
import store from '../../../../store/Store';
import rootReducer from '../../../../store/Reducers';
import Application from '../App';
import { DriversLicenseLookupUtils } from './Utils/DriversLicenseLookupUtils';

interface IDriversLicenseProps {
  component: any;
  form: any;
  value: string;
  onChange: (value?: string) => void;
  isValid: boolean;
}

interface IDriversLicenseState {
  value: string;
  url: string;
  isValid: boolean;
  shouldFocus: boolean;
}

const driversLicenseRequest = {
  vehicleIdRequest: true,
  driversLicense: '',
};

const reduxStore = store({}, rootReducer);

export default class DriversLicenseLookupComponentReact extends React.Component<
  IDriversLicenseProps,
  IDriversLicenseState,
  DmvVehicleData
> {
  private textInputRef!: HTMLInputElement;
  state: IDriversLicenseState = {
    url: '',
    value: this.props.value,
    isValid: this.props.isValid,
    shouldFocus: false
  };

  componentDidUpdate(prevProps: IDriversLicenseProps, prevState: IDriversLicenseState) {
    if (this.state.shouldFocus) {
        this.textInputRef && this.textInputRef.focus();
        this.setState({ shouldFocus: false });
    }

    if (prevState.value != this.state.value) {
        this.props.onChange(this.state.value);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(this.state.shouldFocus == true && nextState.shouldFocus == false);
  }

  executeDriversLicenseSearch = (rawValue: string) => {
    driversLicenseRequest.driversLicense = (rawValue || '').trim();
    if (!driversLicenseRequest.driversLicense) {
      return;
    }

    const backendUrl = reduxStore.getState().valueOf();
    const object = backendUrl.valueOf();
    const url = object['Application'];
    const baseUrl = url['backendURL'];

    const uri =
      baseUrl +
      urls.DRIVERS_LICENSE_LOOKUP +
      '?dlNumber=' +
      encodeURIComponent(driversLicenseRequest.driversLicense);

    const driversLicenseInfo = DriversLicenseLookupUtils.DriversLicenseSearch(uri);

    driversLicenseInfo.then((data) => {
      console.log('data', data);
      DriversLicenseLookupUtils.ProcessDriversLicense(
        data,
        this.props.component,
        this.props.form
      );
    });
  };

  searchDriversLicense = (e) => {
    this.executeDriversLicenseSearch(e?.target?.value);
  };

  onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.executeDriversLicenseSearch(e?.target?.value);
    }
  };


  onChange = e => {
    this.setState({ value: e.target.value });
  };

  focus = () => {
    this.setState({ shouldFocus: true });
  };

  render() {
    const { component } = this.props;

    let className = component.customClass + (component.inputClass && component.inputClass.length ? component.inputClass : "form-control");
    className = this.state.isValid ? className : className + " is-invalid";

    return (
      <div>
        <input
          type='text'
          className={className}
          placeholder={component.placeholder}
          title={component.tooltip}
          tabIndex={component.tabIndex}
          onBlur={this.searchDriversLicense}
          onKeyDown={this.onKeyDown}
          onChange={this.onChange}
          value={this.state.value}
          ref={element => {
            if (element) {
              this.textInputRef = element;
            }
          }}
        />
      </div>
    );
  }
}
